<template>
  <div class="flex flex-col overflow-hidden">
    <div class="flex flex-col h-full border border-gray-300 rounded-xl">
      <!-- Header -->
      <div class="bg-white border border-gray-200 rounded-t-xl">
        <div class="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-1.5 rounded-t-xl border-b border-gray-200">
          <div class="flex items-center">
            <div class="flex items-center space-x-3">
              <button
                type="button"
                class="cursor-pointer"
                @click="$props.expanded ? $emit('shrink') : $emit('expand')"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" v-if="$props.expanded"
                 
                  class="w-6 h-6 text-gray-900/80 hover:text-gray-900 cursor-pointer transition-colors">
  <path stroke-linecap="round" stroke-linejoin="round" d="M9 9V4.5M9 9H4.5M9 9 3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5 5.25 5.25" />
</svg>

                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" v-else
                 
                  class="w-6 h-6 text-gray-900/80 hover:text-gray-900 cursor-pointer transition-colors">
  <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
</svg>
              </button>

              <h2 class="font-semibold text-gray-900 text-xl">
                {{ selectedPackage?.name }}
              </h2>
            </div>

            <nav
              v-if="selectedPackage"
              class="flex space-x-4 px-6"
              aria-label="Tabs"
            >
              <button
                v-for="tab in tabs"
                :key="tab.id"
                type="button"
                class="py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200"
                :disabled="tab.disabled"
                :title="tab.disabledReason"
                :class="[
                  tab.disabled
                    ? 'border-transparent text-gray-300 cursor-not-allowed'
                    : activeTab === tab.id
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                ]"
                @click="selectTab(tab)"
              >
                <div class="flex items-center space-x-2">
                  <svg
    viewBox="0 0 24 24"
    fill="none"
 v-if="tab.id === 'details'"
                    class="w-4 h-4">
    <path
        d="M8 5.00005C7.01165 5.00082 6.49359 5.01338 6.09202 5.21799C5.71569 5.40973 5.40973 5.71569 5.21799 6.09202C5 6.51984 5 7.07989 5 8.2V17.8C5 18.9201 5 19.4802 5.21799 19.908C5.40973 20.2843 5.71569 20.5903 6.09202 20.782C6.51984 21 7.07989 21 8.2 21H15.8C16.9201 21 17.4802 21 17.908 20.782C18.2843 20.5903 18.5903 20.2843 18.782 19.908C19 19.4802 19 18.9201 19 17.8V8.2C19 7.07989 19 6.51984 18.782 6.09202C18.5903 5.71569 18.2843 5.40973 17.908 5.21799C17.5064 5.01338 16.9884 5.00082 16 5.00005M8 5.00005V7H16V5.00005M8 5.00005V4.70711C8 4.25435 8.17986 3.82014 8.5 3.5C8.82014 3.17986 9.25435 3 9.70711 3H14.2929C14.7456 3 15.1799 3.17986 15.5 3.5C15.8201 3.82014 16 4.25435 16 4.70711V5.00005"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>

                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-else-if="tab.id === 'procurement'"
                    class="w-4 h-4">
    <path clip-rule="evenodd" d="m7.33755 4.30894c.30652-1.18429 1.38234-2.05894 2.66245-2.05894h4c1.2801 0 2.3559.87465 2.6624 2.05894 1.5999.28654 2.8416 1.57693 3.0555 3.20159.0322.24459.0322.52292.0321.93158v.00003.05786 7.7.0321c0 .8129 0 1.4685-.0434 1.9994-.0446.5466-.139 1.0267-.3653 1.471-.3596.7056-.9332 1.2793-1.6388 1.6388-.4443.2263-.9244.3207-1.471.3653-.5309.0434-1.1865.0434-1.9994.0434h-.0321-4.4-.03213c-.81283 0-1.46844 0-1.99934-.0434-.54664-.0446-1.02678-.139-1.471-.3653-.7056-.3595-1.27928-.9332-1.63881-1.6388-.22634-.4443-.3207-.9244-.36536-1.471-.04338-.5309-.04337-1.1866-.04336-1.9994v-.0321-7.7l-.00001-.05786c-.00007-.40868-.00011-.68702.03209-.93161.21389-1.62466 1.45558-2.91505 3.05547-3.20159zm.04216 1.52812c-.85075.24354-1.49225.97131-1.61046 1.86926-.01764.13392-.01925.30542-.01925.79368v7.7c0 .8525.00058 1.4467.03838 1.9093.03708.4539.10621.7147.20685.9122.21572.4233.55992.7675.98329.9833.19752.1006.45828.1697.91216.2068.46263.0378 1.05686.0384 1.90932.0384h4.4c.8525 0 1.4467-.0006 1.9093-.0384.4539-.0371.7147-.1062.9122-.2068.4233-.2158.7675-.56.9833-.9833.1006-.1975.1697-.4583.2068-.9122.0378-.4626.0384-1.0568.0384-1.9093v-7.7c0-.48826-.0016-.65976-.0193-.79368-.1182-.89795-.7597-1.62572-1.6104-1.86926-.3541 1.10947-1.3934 1.91294-2.6203 1.91294h-4c-1.22691 0-2.26617-.80347-2.62029-1.91294zm2.62029-2.08706c-.69036 0-1.25.55964-1.25 1.25s.55964 1.25 1.25 1.25h4c.6904 0 1.25-.55964 1.25-1.25s-.5596-1.25-1.25-1.25zm-2.75 7.25c0-.4142.33578-.75.75-.75h8c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-8c-.41422 0-.75-.3358-.75-.75zm.75 2.25c-.41422 0-.75.3358-.75.75s.33578.75.75.75h8c.4142 0 .75-.3358.75-.75s-.3358-.75-.75-.75zm-.75 3.75c0-.4142.33578-.75.75-.75h6c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-6c-.41422 0-.75-.3358-.75-.75z" fill="currentColor" fill-rule="evenodd"/>
</svg>

                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-else-if="tab.id === 'security'"
                    class="w-4 h-4">
    <path d="M9 12L11 14L15 9.99999M20 12C20 16.4611 14.54 19.6937 12.6414 20.683C12.4361 20.79 12.3334 20.8435 12.191 20.8712C12.08 20.8928 11.92 20.8928 11.809 20.8712C11.6666 20.8435 11.5639 20.79 11.3586 20.683C9.45996 19.6937 4 16.4611 4 12V8.21759C4 7.41808 4 7.01833 4.13076 6.6747C4.24627 6.37113 4.43398 6.10027 4.67766 5.88552C4.9535 5.64243 5.3278 5.50207 6.0764 5.22134L11.4382 3.21067C11.6461 3.13271 11.75 3.09373 11.857 3.07827C11.9518 3.06457 12.0482 3.06457 12.143 3.07827C12.25 3.09373 12.3539 3.13271 12.5618 3.21067L17.9236 5.22134C18.6722 5.50207 19.0465 5.64243 19.3223 5.88552C19.566 6.10027 19.7537 6.37113 19.8692 6.6747C20 7.01833 20 7.41808 20 8.21759V12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 v-else-if="tab.id === 'package-items'"
                    class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
    />
</svg>

                  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 v-else-if="tab.id === 'times-targets'"
                    class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
    />
</svg>

                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-else-if="tab.id === 'tender-evaluation'"
                    class="w-4 h-4">
    <path clip-rule="evenodd" d="m7.33755 4.30894c.30652-1.18429 1.38234-2.05894 2.66245-2.05894h4c1.2801 0 2.3559.87465 2.6624 2.05894 1.5999.28654 2.8416 1.57693 3.0555 3.20159.0322.24459.0322.52292.0321.93158v.00003.05786 7.7.0321c0 .8129 0 1.4685-.0434 1.9994-.0446.5466-.139 1.0267-.3653 1.471-.3596.7056-.9332 1.2793-1.6388 1.6388-.4443.2263-.9244.3207-1.471.3653-.5309.0434-1.1865.0434-1.9994.0434h-.0321-4.4-.03213c-.81283 0-1.46844 0-1.99934-.0434-.54664-.0446-1.02678-.139-1.471-.3653-.7056-.3595-1.27928-.9332-1.63881-1.6388-.22634-.4443-.3207-.9244-.36536-1.471-.04338-.5309-.04337-1.1866-.04336-1.9994v-.0321-7.7l-.00001-.05786c-.00007-.40868-.00011-.68702.03209-.93161.21389-1.62466 1.45558-2.91505 3.05547-3.20159zm.04216 1.52812c-.85075.24354-1.49225.97131-1.61046 1.86926-.01764.13392-.01925.30542-.01925.79368v7.7c0 .8525.00058 1.4467.03838 1.9093.03708.4539.10621.7147.20685.9122.21572.4233.55992.7675.98329.9833.19752.1006.45828.1697.91216.2068.46263.0378 1.05686.0384 1.90932.0384h4.4c.8525 0 1.4467-.0006 1.9093-.0384.4539-.0371.7147-.1062.9122-.2068.4233-.2158.7675-.56.9833-.9833.1006-.1975.1697-.4583.2068-.9122.0378-.4626.0384-1.0568.0384-1.9093v-7.7c0-.48826-.0016-.65976-.0193-.79368-.1182-.89795-.7597-1.62572-1.6104-1.86926-.3541 1.10947-1.3934 1.91294-2.6203 1.91294h-4c-1.22691 0-2.26617-.80347-2.62029-1.91294zm2.62029-2.08706c-.69036 0-1.25.55964-1.25 1.25s.55964 1.25 1.25 1.25h4c.6904 0 1.25-.55964 1.25-1.25s-.5596-1.25-1.25-1.25zm-2.75 7.25c0-.4142.33578-.75.75-.75h8c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-8c-.41422 0-.75-.3358-.75-.75zm.75 2.25c-.41422 0-.75.3358-.75.75s.33578.75.75.75h8c.4142 0 .75-.3358.75-.75s-.3358-.75-.75-.75zm-.75 3.75c0-.4142.33578-.75.75-.75h6c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-6c-.41422 0-.75-.3358-.75-.75z" fill="currentColor" fill-rule="evenodd"/>
</svg>

                  <span>{{ tab.name }}</span>
                </div>
              </button>
            </nav>

            <div class="flex items-center space-x-2 ml-auto">
              <button
                v-if="projectsStore.project?.unarchived && falsey(selectedPackage.locked_at)"
                type="button"
                class="btn btn--secondary-blue flex items-center space-x-2"
                @click="showTradeItemSelector = !showTradeItemSelector"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
  <path fill-rule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clip-rule="evenodd" />
</svg>

                <span>{{ $t('Subcontract.PackagesDashboard.PackageBreakdown.button.addTradeItems') }}</span>
              </button>

              <button
                v-if="projectsStore.project?.unarchived && falsey(selectedPackage.locked_at) && packageTradeItems.length > 0"
                type="button"
                class="btn btn--secondary-blue flex items-center space-x-2"
                @click="showBulkAssignWbsModal = true"
              >
                <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
    />
</svg>

                <span>Assign WBS Code to all items</span>
              </button>

              <RouterLink
                v-if="selectedPackage.locked_at"
                :to="{ name: 'PackageVariationsSchedule', params: { projectId: project.id, packageId: selectedPackage.id } }"
                class="btn btn--secondary-blue flex items-center space-x-2"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
    <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
  </svg>

                <span>View Variations</span>
              </RouterLink>

              <div
                v-if="selectedPackage.locked_at"
                class="text-sm text-gray-900 flex space-x-2 items-center"
                title="Package has at least one claim. Package items cannot be edited."
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
</svg>

                <span>
                  Package Locked
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab Content -->
      <div class="flex-1 overflow-hidden bg-white rounded-b-xl">
        <div
          v-if="showPackagesAction.is(States.LOADING) && showPackagesAction.requestTime.value > 3"
          class="flex justify-center items-center h-full"
        >
          <div class="flex flex-col items-center">
            <AppSpinner />

            <p class="mt-4 text-sm text-gray-500">
              Loading package details...
            </p>
          </div>
        </div>

        <div
          v-else
          class="h-full flex"
        >
          <!-- Package Items / Times / Tender: full width -->
          <template v-if="['package-items', 'times-targets', 'tender-evaluation'].includes(activeTab)">
            <div class="flex-1 flex flex-col min-w-0 min-h-0">
              <TimesAndTargetsTab
                v-if="activeTab === 'times-targets'"
                :selected-package="selectedPackage"
                :can-save="!!projectsStore.project?.unarchived"
              />

              <TenderEvaluationTab
                v-else-if="activeTab === 'tender-evaluation'"
                :selected-package="selectedPackage"
                :can-save="!!projectsStore.project?.unarchived && falsey(selectedPackage.locked_at)"
              />

              <PackageTradeItemsTable
                v-else
                ref="tradeItemsTableRef"
                :package-trade-items-by-trade="packageTradeItemsByTrade"
                :selected-trade-items-by-trade="selectedTradeItemsByTrade"
                :package-trade-items="packageTradeItems"
                :selected-trade-items="selectedTradeItems"
                :selected-package="selectedPackage"
                :show-edit-buttons="projectsStore.project?.unarchived && falsey(selectedPackage.locked_at)"
                :total-budget="totalBudget"
                :total-awarded="totalAwarded"
                :total-profit="totalProfit"
                :table-mode="tableMode"
                @table-mode-changed="tableMode = $event"
                @delete="deletePackageTradeItem"
                @package-trade-item-created="onPackageTradeItemCreated"
                @package-trade-item-removed="deselectTradeItem"
              />
            </div>
          </template>

          <!-- Other tabs: side panel + table -->
          <template v-else>
            <div class="h-full flex w-1/4 min-w-0 border-r border-gray-200">
              <PackageDetailsTab
                v-if="activeTab === 'details'"
                :selected-package="selectedPackage"
                :can-save="!!projectsStore.project?.unarchived"
              />

              <ProcurementStrategyTab
                v-else-if="activeTab === 'procurement'"
                :selected-package="selectedPackage"
                :can-save="!!projectsStore.project?.unarchived"
              />

              <PerformanceSecurityTab
                v-else-if="activeTab === 'security'"
                :selected-package="selectedPackage"
                :can-save="!!projectsStore.project?.unarchived"
              />
            </div>

            <div class="flex-1 flex flex-col border-l border-gray-200 min-w-0">
              <PackageTradeItemsTable
                ref="tradeItemsTableRef"
                :package-trade-items-by-trade="packageTradeItemsByTrade"
                :selected-trade-items-by-trade="selectedTradeItemsByTrade"
                :package-trade-items="packageTradeItems"
                :selected-trade-items="selectedTradeItems"
                :selected-package="selectedPackage"
                :show-edit-buttons="projectsStore.project?.unarchived && falsey(selectedPackage.locked_at)"
                :total-budget="totalBudget"
                :total-awarded="totalAwarded"
                :total-profit="totalProfit"
                :table-mode="tableMode"
                @table-mode-changed="tableMode = $event"
                @delete="deletePackageTradeItem"
                @package-trade-item-created="onPackageTradeItemCreated"
                @package-trade-item-removed="deselectTradeItem"
              />
            </div>
          </template>
        </div>
      </div>
    </div>

    <TradeItemSaveModal
      v-if="addingNewTradeItem"
      :package="selectedPackage"
      @close="addingNewTradeItem = false; showTradeItemSelector = true"
    />

    <TradeItemSelectorModal
      v-if="showTradeItemSelector"
      :package="$props.selectedPackage"
      :selected-trade-items="selectedTradeItems"
      @close="showTradeItemSelector = false"
      @select-trade-item="selectTradeItem($event)"
      @deselect-trade-item="deselectTradeItem($event)"
      @new-trade-item="showTradeItemSelector = false; addingNewTradeItem = true;"
    />

    <ProjectSupplierModal
      v-if="showSupplierModal"
      :project-supplier="selectedProjectSupplier"
      :project-id="projectsStore.project.id"
      @close="showSupplierModal = false"
    />

    <BulkAssignWbsCodeModal
      v-if="showBulkAssignWbsModal"
      :package-id="selectedPackage.id"
      :package="selectedPackage"
      :package-trade-items="packageTradeItems"
      @close="showBulkAssignWbsModal = false"
      @assigned="handleWbsCodeAssigned"
    />
  </div>
</template>

<script setup lang="ts">
import ProjectSupplierModal from '@/components/ProjectSettings/VendorsTab/ProjectSupplierModal.vue';
import { States, useStoreApiAction } from '@/composables/useStoreApiAction';
import { falsey } from '@/helpers';
import { t } from '@/i18n';
import Package from '@/models/Package';
import PackageTradeItem from '@/models/PackageTradeItem';
import Trade from '@/models/Trade';
import TradeItem from '@/models/TradeItem';
import { usePackagesStore } from '@/store/packages';
import { usePackageTradeItemsStore } from '@/store/packageTradeItems';
import { useProjectsStore } from '@/store/projects';
import { useTradeItemsStore } from '@/store/tradeItems';
import { useTradesStore } from '@/store/trades';
import Swal from 'sweetalert2';
import { computed, nextTick, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import BulkAssignWbsCodeModal from './BulkAssignWbsCodeModal.vue';
import PackageDetailsTab from './PackageDetailsTab.vue';
import PackageTradeItemsTable from './PackageTradeItemsTable.vue';
import PerformanceSecurityTab from './PerformanceSecurityTab.vue';
import ProcurementStrategyTab from './ProcurementStrategyTab.vue';
import TenderEvaluationTab from './TenderEvaluationTab.vue';
import TimesAndTargetsTab from './TimesAndTargetsTab.vue';
import TradeItemSaveModal from './TradeItemSaveModal.vue';
import TradeItemSelectorModal from './TradeItemSelectorModal.vue';

const props = defineProps<{
  selectedPackage: Package;
  expanded: boolean;
}>();

const emits = defineEmits<{
  (e: 'expand');
  (e: 'shrink');
}>();

const packageTradeItemsStore = usePackageTradeItemsStore();
const projectsStore = useProjectsStore();
const packagesStore = usePackagesStore();
const tradeItemsStore = useTradeItemsStore();
const addingNewTradeItem = ref(false);
const showTradeItemsAction = useStoreApiAction(tradeItemsStore.show);
const showPackagesAction = useStoreApiAction(packagesStore.show);
const selectedTradeItemIds = ref<Id[]>([]);
const tradeItemsTableRef = ref<InstanceType<typeof PackageTradeItemsTable>>(undefined);

const project = computed(() => {
  return projectsStore.project;
});

const packageTradeItems = computed(() => {
  return packageTradeItemsStore.models
    .where('package_id', props.selectedPackage.id)
    .with('trade_item', (query) => {
      query.with('trade');
    })
    .with('trade')
    .with('wbs_code')
    .orderBy('sort_order')
    .get();
});

// Tab management
const activeTab = ref('details');

const selectTab = (tab: typeof tabs.value[number]) => {
  if(tab.disabled) {
    return;
  }

  activeTab.value = tab.id;
};

const packagesLite = computed(() => {
  return !!projectsStore.project?.feature_flag_subcontractor_packages_lite;
});

const canOpenTenderEvaluation = computed(() => {
  return !!props.selectedPackage.procurement_method && packageTradeItems.value.length > 0;
});

const tenderEvaluationDisabledReason = computed(() => {
  if(canOpenTenderEvaluation.value) {
    return undefined;
  }

  if(!props.selectedPackage.procurement_method && packageTradeItems.value.length === 0) {
    return 'Set a procurement method and add package items before opening tender evaluation';
  }

  if(!props.selectedPackage.procurement_method) {
    return 'Set a procurement method before opening tender evaluation';
  }

  return 'Add items to the package before opening tender evaluation';
});

const tabs = computed(() => {
  const base = [
    {
      id: 'package-items',
      name: 'Package Items',
      disabled: false,
      disabledReason: undefined as string | undefined,
    },
    {
      id: 'details',
      name: 'Package Details',
      disabled: false,
      disabledReason: undefined as string | undefined,
    },
    {
      id: 'procurement',
      name: 'Procurement Strategy',
      disabled: false,
      disabledReason: undefined as string | undefined,
    },
    {
      id: 'security',
      name: 'Performance Security',
      disabled: false,
      disabledReason: undefined as string | undefined,
    },
  ];

  if(!packagesLite.value) {
    base.splice(3, 0, {
      id: 'times-targets',
      name: 'Times & Targets',
      disabled: false,
      disabledReason: undefined as string | undefined,
    }, {
      id: 'tender-evaluation',
      name: 'Tender Evaluation',
      disabled: !canOpenTenderEvaluation.value,
      disabledReason: tenderEvaluationDisabledReason.value,
    });
  }

  return base;
});

watch(() => props.selectedPackage.id, (newValue) => {
  if(newValue) {
    showPackagesAction.request(newValue);
    selectedTradeItemIds.value = [];
  }
}, { immediate: true });

watch(canOpenTenderEvaluation, (canOpen) => {
  if(!canOpen && activeTab.value === 'tender-evaluation') {
    activeTab.value = 'details';
  }
});

const selectTradeItem = (tradeItem: TradeItem) => {
  if(selectedTradeItemIds.value.findIndex((id) => id === tradeItem.id) === -1) {
    // showTradeItemsAction.request(tradeItem.id).then(() => {
    // });
    selectedTradeItemIds.value.push(tradeItem.id);
  }
};

const deselectTradeItem = (tradeItem: TradeItem) => {
  selectedTradeItemIds.value.splice(
    selectedTradeItemIds.value.findIndex((tradeItemId) => tradeItemId === tradeItem.id),
    1,
  );
};

const onPackageTradeItemCreated = (payload: { tradeItem: TradeItem; addedVia: 'rate' | 'value' }) => {
  const { tradeItem, addedVia } = payload;
  const indexForRow = selectedTradeItemIds.value.findIndex((id) => id === tradeItem.id);
  const nextIndex = (indexForRow + 1) % selectedTradeItemIds.value.length;
  const nextTradeItemId = selectedTradeItemIds.value[nextIndex];

  selectedTradeItemIds.value.splice(indexForRow, 1);

  if(selectedTradeItemIds.value.length > 0) {
    nextTick(() => {
      if(nextTradeItemId && tradeItemsTableRef.value?.focusNextFormRow) {
        tradeItemsTableRef.value.focusNextFormRow(nextTradeItemId, addedVia);
      }
    });
  }
};

const selectedTradeItems = computed(() => {
  return tradeItemsStore.models
    .with('package_trade_items', (query) => {
      query.where('package_id', props.selectedPackage.id);
    })
    .with('trade')
    .whereId(selectedTradeItemIds.value)
    .get();
});

const selectedTradeItemsByTrade = computed(() => {
  const tradesMap = new Map<Id, { trade: Trade; items: TradeItem[] }>();

  selectedTradeItems.value.forEach((tradeItem) => {
    const key = tradeItem.trade_id;

    if(tradesMap.has(key)) {
      tradesMap.get(key).items.push(tradeItem);
    } else {
      tradesMap.set(key, {
        trade: tradeItem.trade,
        items: [tradeItem],
      });
    }
  });

  return tradesMap;
});

const getRootTradeItem = (tradeItem: TradeItem): TradeItem => {
  let current = tradeItemsStore.models.find(tradeItem.id) ?? tradeItem;

  while(current.parent_id) {
    const parent = tradeItemsStore.models.find(current.parent_id);

    if(!parent) {
      break;
    }

    current = parent;
  }

  return current;
};

const tableMode = ref<('full' | 'compact')>('full');

const packageTradeItemsByTrade = computed(() => {
  const tradesMap = new Map<
    Id,
    { trade: Trade | undefined; items: { tradeItem: TradeItem; packageTradeItem: PackageTradeItem }[] }
  >();

  tradesMap.set('unset', { trade: undefined, items: [] });

  if(tableMode.value === 'compact') {
    packageTradeItems.value.forEach((packageTradeItem) => {
      const key = packageTradeItem.trade_item?.trade_id ?? 'unset';

      if(!tradesMap.has(key)) {
        tradesMap.set(key, {
          trade: packageTradeItem.trade?.length ? packageTradeItem.trade[0] : undefined,
          items: [],
        });
      }

      tradesMap.get(key).items.push({ tradeItem: packageTradeItem.trade_item, packageTradeItem });
    });

    return tradesMap;
  }

  const rootsByTrade = new Map<Id, Map<Id, { tradeItem: TradeItem; packageTradeItem: PackageTradeItem }>>();

  // Find all top level items
  packageTradeItems.value.forEach((packageTradeItem) => {
    const tradeItem = packageTradeItem.trade_item;
    const root = getRootTradeItem(tradeItem);
    const tradeKey = packageTradeItem.trade_item.trade?.id ?? root.trade_id ?? 'unset';

    if(!rootsByTrade.has(tradeKey)) {
      rootsByTrade.set(tradeKey, new Map());
    }

    rootsByTrade.get(tradeKey).set(root.id, { tradeItem: root, packageTradeItem });
  });

  // Get all root items for each trade
  rootsByTrade.forEach((roots, tradeKey) => {
    const items = Array.from(roots.values()).sort((a, b) =>
      a.packageTradeItem.sort_order - b.packageTradeItem.sort_order
    );

    const firstPackageTradeItem = packageTradeItems.value.find((packageTradeItem) => {
      return getRootTradeItem(packageTradeItem.trade_item).id === items[0]?.tradeItem.id;
    });

    tradesMap.set(tradeKey, {
      trade: tradeKey === 'unset' ? undefined : firstPackageTradeItem?.trade_item?.trade,
      items,
    });
  });

  return tradesMap;
});

const totalBudget = computed(() => {
  return packageTradeItems.value.reduce((total, packageTradeItem) => {
    return total += packageTradeItem.trade_item.budget;
  }, 0);
});

const totalAwarded = computed(() => {
  return packageTradeItems.value.reduce((total, packageTradeItem) => {
    return total += packageTradeItem.value;
  }, 0);
});

const totalProfit = computed(() => {
  return packageTradeItems.value.reduce((total, pti) => {
    const pct = pti.awarded_works ?? 100;

    return total + ((pti.trade_item.budget * (pct / 100)) - pti.value);
  }, 0);
});

const deletePackageTradeItemAction = useStoreApiAction(packageTradeItemsStore.delete);

const deletePackageTradeItem = (packageTradeItem: PackageTradeItem) => {
  Swal.fire({
    icon: 'warning',
    title: t('Subcontract.PackagesDashboard.PackageBreakdown.message.removeTradeItemTitle'),
    text: t('Subcontract.PackagesDashboard.PackageBreakdown.message.removeTradeItemText', {
      name: packageTradeItem.trade_item.name,
    }),

    showCancelButton: true,
  }).then((result) => {
    if(result.isConfirmed) {
      deletePackageTradeItemAction.request(packageTradeItem.id).catch((error) => {
        console.log(error);

        Swal.fire({
          icon: 'error',
          title: t('Subcontract.PackagesDashboard.PackageBreakdown.message.failedToRemoveTradeItem'),
        });
      });
    }
  });
};

const showTradeItemSelector = ref(false);

const selectedProjectSupplier = computed(() => {
  return props.selectedPackage.subcontractor?.projects[0];
});

const showSupplierModal = ref(false);
const showBulkAssignWbsModal = ref(false);

const handleWbsCodeAssigned = () => {
  showPackagesAction.request(props.selectedPackage.id);
};
</script>

<style scoped></style>
